import { render, staticRenderFns } from "./MstfList.vue?vue&type=template&id=6c2745fe&scoped=true&"
import script from "./MstfList.vue?vue&type=script&lang=js&"
export * from "./MstfList.vue?vue&type=script&lang=js&"
import style0 from "./MstfList.vue?vue&type=style&index=0&id=6c2745fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2745fe",
  null
  
)

export default component.exports